export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10485.a9df3b1f.jpg";